import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import { LEGACY_PAYMENT_HOSTNAME, NEW_PAYMENT_HOSTNAME } from './config/urls'
import './index.css'

if (
  window.location.hostname === LEGACY_PAYMENT_HOSTNAME &&
  !window.location.pathname.startsWith('/api/payment/callback')
) {
  const redirectedUrl = `https://${NEW_PAYMENT_HOSTNAME}${window.location.pathname}${window.location.search}${window.location.hash}`;
  window.location.replace(redirectedUrl);
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
